import DownloadingIcon from '@mui/icons-material/Downloading';
import InfoIcon from '@mui/icons-material/Info';
import UpdateIcon from '@mui/icons-material/Update';
import toast, { Renderable, ToastOptions, ValueOrFunction } from 'react-hot-toast';

interface ToastData {
    message: string;
    options: ToastOptions;
}

interface PromiseMsgsData {
    error: ValueOrFunction<Renderable, unknown>;
    loading: Renderable;
    success: ValueOrFunction<Renderable, unknown>;
}

interface ToastPromiseData {
    msgs: PromiseMsgsData;
    opts: ToastOptions;
}

export const addTagLinkSuccess = {
    message: 'Tag link added successfully.',
    options: { id: 'addTagLinkSuccess' },
};

export const addTagLinkError = {
    message: 'Failed to add tag link.',
    options: { id: 'addTagLinkError' },
};

export const doorRequestActive = {
    message: 'You already have an active door request. Please wait a few minutes.',
    options: { id: 'doorRequestActive' },
};

export const feedAddedSuccess = {
    message: 'Feed added successfully.',
    options: { id: 'feedAddedSuccess' },
};

export const feedAddedError = {
    message: 'Failed to add feed.',
    options: { id: 'feedAddedError' },
};

export const eventDeletedSuccess = {
    message: 'Event deleted successfully.',
    options: { id: 'eventDeletedSuccess' },
};

export const eventDeletedError = {
    message: 'Event deletion failed.',
    options: { id: 'eventDeletedError' },
};

export const eventMovedSuccess = {
    message: 'Event moved successfully.',
    options: { id: 'eventMovedSuccess' },
};

export const eventMovedError = {
    message: 'Event move failed.',
    options: { id: 'eventMovedError' },
};

export const eventUpdatedSuccess = {
    message: 'Event updated successfully.',
    options: { id: 'eventUpdatedSuccess' },
};

export const eventUpdatedError = {
    message: 'Event update failed.',
    options: { id: 'eventUpdatedError' },
};

export const eventCreatedSuccess = {
    message: 'Event created successfully.',
    options: { id: 'eventCreatedSuccess' },
};

export const eventCreatedError = {
    message: 'Event creation failed.',
    options: { id: 'eventCreatedError' },
};

export const calendarFeedSuccess = {
    message: 'Calendar feed loaded successfully.',
    options: { id: 'calendarFeedSuccess' },
};

export const calendarFeedError = {
    message: 'Failed to load calendar feed.',
    options: { id: 'calendarFeedError' },
};

export const imageModerationError = {
    message: 'Image rejected. Content violates our guidelines.',
    options: { id: 'imageModerationError' },
};

export const redirectTagSuccess = {
    message: 'Redirect saved.',
    options: { id: 'redirectTagSuccess' },
};

export const redirectTagError = {
    message: 'Redirect saving failed.',
    options: { id: 'redirectTagError' },
};

export const claimTagSuccess = {
    message: 'Tag claimed.',
    options: { id: 'claimTagSuccess' },
};

export const claimTagError = {
    message: 'Tag claim failed.',
    options: { id: 'claimTagError' },
};

export const formValidationError = {
    message: 'Form needs more information. Please fill other fields.',
    options: { id: 'formValidationError' },
};

export const inviteLinkSuccess = {
    message: 'Invitation link created.',
    options: { id: 'inviteLinkSuccess' },
};

export const inviteLinkError = {
    message: 'Link creation failed.',
    options: { id: 'inviteLinkError' },
};

export const inviteSendSuccess = {
    message: 'Invitation sent.',
    options: { id: 'inviteSendSuccess' },
};

export const inviteSendError = {
    message: 'Invite sending failed.',
    options: { id: 'inviteSendError' },
};

export const measurementReportUploadedSuccess = {
    message: 'Report uploaded.',
    options: { id: 'measurementReportUploadedSuccess' },
};

export const measurementReportBundleUploadedSuccess = {
    message: 'Report bundle uploaded.',
    options: { id: 'measurementReportBundleUploadedSuccess' },
};

export const messageSendSuccess = {
    message: 'Message sent.',
    options: { id: 'messageSendSuccess' },
};

export const messageSendError = {
    message: 'Sending failed.',
    options: { id: 'messageSendError' },
};

export const layerUpdatedSuccess = {
    message: 'Layer updated.',
    options: { id: 'layerUpdatedSuccess' },
};

export const layerUpdatedError = {
    message: 'Layer update failed.',
    options: { id: 'layerUpdatedError' },
};

export const areaUpdatedSuccess = {
    message: 'Area updated.',
    options: { id: 'areaUpdatedSuccess' },
};

export const areaUpdatedError = {
    message: 'Area update failed.',
    options: { id: 'areaUpdatedError' },
};

export const applicationRejectInfo = {
    message: 'Application rejected.',
    options: { id: 'applicationRejectInfo' },
};

export const stepsCompletedSuccess = {
    message: 'All steps successfully completed.',
    options: { id: 'stepsCompletedSuccess' },
};

export const somethingWrongError = {
    message: 'Something went wrong.',
    options: { id: 'somethingWrongError' },
};

export const generalManagerSuccess = {
    message: 'Success',
    options: { id: 'generalManagerSuccess' },
};

export const generalManagerError = {
    message: 'Error',
    options: { id: 'generalManagerError' },
};

export const settingsUpdatedSuccess = {
    message: 'Settings updated.',
    options: { id: 'settingsUpdatedSuccess' },
};

export const settingsUpdatedError = {
    message: 'Update failed.',
    options: { id: 'settingsUpdatedError' },
};

export const deleteTokenSuccess = {
    message: 'Token deleted.',
    options: { id: 'deleteTokenSuccess' },
};

export const deleteTokenError = {
    message: 'Token delete failed.',
    options: { id: 'deleteTokenError' },
};

export const copyClipboardSuccess = {
    message: 'Copied to clipboard.',
    options: { id: 'copyClipboardSuccess' },
};

export const copyClipboardError = {
    message: 'Copy to clipboard failed.',
    options: { id: 'copyClipboardError' },
};

export const userKickSuccess = {
    message: 'User kicked.',
    options: { id: 'userKickSuccess' },
};

export const userKickError = {
    message: 'User kick failed.',
    options: { id: 'userKickError' },
};

export const emojiSentSuccess = {
    message: 'Emoji sent.',
    options: { id: 'emojiSentSuccess' },
};

export const emojiSentError = {
    message: 'Emoji sending failed.',
    options: { id: 'emojiSentError' },
};

export const infoscreenCreatedSuccess = {
    message: 'Infoscreen token created.',
    options: { duration: 4000, id: 'infoscreenCreatedSuccess' },
};

export const infoscreenCreatedError = {
    message: 'Infoscreen token creation failed.',
    options: { id: 'infoscreenCreatedError' },
};

export const deviceCurrentUpdatedSuccess = {
    message: 'Current device data updated.',
    options: { id: 'deviceCurrentUpdatedSuccess' },
};

export const deviceUpdatedSuccess = {
    message: 'Device data updated.',
    options: { id: 'deviceUpdatedSuccess' },
};

export const deviceUpdatedError = {
    message: 'Device update failed.',
    options: { id: 'deviceUpdatedError' },
};

export const deviceCreatedSuccess = {
    message: 'Device created.',
    options: { id: 'deviceCreatedSuccess' },
};

export const deviceCreatedError = {
    message: 'Device creation failed.',
    options: { id: 'deviceCreatedError' },
};

export const configLoadError = {
    message: 'Failed to load device configuration. Please restart the app or check your connection.',
    options: { id: 'configLoadError' },
};

export const geocodingError = {
    message: 'Failed to fetch location.',
    options: { id: 'geocodingError' },
};

export const selectLayerInfo = {
    message: 'Select a layer first.',
    options: {
        icon: <InfoIcon sx={{ color: '#4EC1ED' }} />,
        id: 'selectLayerInfo',
    },
};

export const fillFormInfo = {
    message: 'Please fill in all fields.',
    options: {
        icon: <InfoIcon sx={{ color: '#4EC1ED' }} />,
        id: 'fillFormInfo',
    },
};

export const offlineDisplayInfo = {
    message: 'Content is cached for offline use.',
    options: {
        icon: <DownloadingIcon sx={{ color: '#44B700' }} />,
        id: 'offlineDisplay',
    },
};

export const emailPromise = {
    msgs: {
        error: 'Email sending failed.',
        loading: 'Sending..',
        success: 'Email sent.',
    },
    opts: { id: 'emailPromise' },
};

export const actionPromise = {
    msgs: {
        error: 'Action failed.',
        loading: 'Loading..',
        success: 'Action completed.',
    },
    opts: { id: 'actionPromise' },
};

export const imageDeletePromise = {
    msgs: {
        error: 'Image delete failed.',
        loading: 'Deleting..',
        success: 'Image deleted.',
    },
    opts: { id: 'imageDeletePromise' },
};

export const imageUpdatePromise = {
    msgs: {
        error: 'Image update failed.',
        loading: 'Updating..',
        success: 'Image updated.',
    },
    opts: { id: 'imageUpdatePromise' },
};

export const imageUploadPromise = {
    msgs: {
        error: 'Image upload failed.',
        loading: 'Uploading..',
        success: 'Image uploaded.',
    },
    opts: { id: 'imageUploadPromise' },
};

export const requestHandlePromise = {
    msgs: {
        error: 'Request handling failed.',
        loading: 'Loading..',
        success: 'Request handled.',
    },
    opts: { id: 'requestHandlePromise' },
};

export const requestSendPromise = {
    msgs: {
        error: 'Request sending failed.',
        loading: 'Sending..',
        success: 'Request sent.',
    },
    opts: { id: 'requestSendPromise' },
};

export const deletePromise = {
    msgs: {
        error: 'Delete failed.',
        loading: 'Deleting..',
        success: 'Deleted.',
    },
    opts: { id: 'deletePromise' },
};

export const deviceDeletePromise = {
    msgs: {
        error: 'Device delete failed.',
        loading: 'Deleting..',
        success: 'Device deleted.',
    },
    opts: { id: 'deviceDeletePromise' },
};

export const deviceUpdatePromise = {
    msgs: {
        error: 'Device update failed.',
        loading: 'Updating device...',
        success: 'Device data updated.',
    },
    opts: { id: 'deviceUpdatePromise' },
};

export const deviceFetchPromise = {
    msgs: {
        error: 'Device fetch failed.',
        loading: 'Fetching devices...',
        success: 'Device fetch success.',
    },
    opts: { id: 'deviceFetchPromise' },
};

export const layerCreatePromise = {
    msgs: {
        error: 'Layer create failed.',
        loading: 'Creating...',
        success: 'Layer created.',
    },
    opts: { id: 'layerCreatePromise' },
};

export const deviceLinkPromise = {
    msgs: {
        error: 'Device link failed.',
        loading: 'Linking...',
        success: 'Device linked.',
    },
    opts: { id: 'deviceLinkPromise' },
};

export const deviceSitePromise = {
    msgs: {
        error: 'Failed to set device site. Make sure that this site does not already have a main device (if you tried to link another main device)',
        loading: 'Updating...',
        success: 'Device site updated.',
    },
    opts: { id: 'deviceSitePromise' },
};

export const infoscreenUpdatePromise = {
    msgs: {
        error: 'Failed to update infoscreen.',
        loading: 'Updating...',
        success: 'Infoscreen updated.',
    },
    opts: { id: 'infoscreenUpdatePromise' },
};

export const companyCreatePromise = {
    msgs: {
        error: 'Failed to create company.',
        loading: 'Creating company...',
        success: 'Company created.',
    },
    opts: { id: 'companyCreatePromise' },
};

export const socialGroupCreatePromise = {
    msgs: {
        error: 'Failed to create social group.',
        loading: 'Creating social group...',
        success: 'Social group created.',
    },
    opts: { id: 'socialGroupCreatePromise' },
};

export const siteCreatePromise = {
    msgs: {
        error: 'Failed to create site.',
        loading: 'Creating site...',
        success: 'Site created.',
    },
    opts: { id: 'siteCreatePromise' },
};

export const supportTicketPromise = {
    msgs: {
        error: 'Process failed.',
        loading: 'Loading...',
        success: 'Support ticket sent.',
    },
    opts: { id: 'supportTicketPromise' },
};

export const claimTagPromise = {
    msgs: {
        error: 'Tag claim failed.',
        loading: 'Claiming...',
        success: 'Tag claimed.',
    },
    opts: { id: 'claimTagPromise' },
};

export const redirectTagPromise = {
    msgs: {
        error: 'Redirect saving failed.',
        loading: 'Saving...',
        success: 'Redirect saved.',
    },
    opts: { id: 'redirectTagPromise' },
};

export const screenCreatePromise = {
    msgs: {
        error: 'Failed to create screen.',
        loading: 'Creating...',
        success: 'Screen created.',
    },
    opts: { id: 'screenCreatePromise' },
};

export const doorOpenPromise = {
    msgs: {
        error: 'Failed to open door.',
        loading: 'Opening door...',
        success: 'Opened door.',
    },
    opts: { id: 'doorOpenPromise' },
};

export const customToast = (data: ToastData) => toast(data.message, data.options);

export const customPromiseToast = (promise: Promise<unknown>, data: ToastPromiseData) =>
    toast.promise(promise, data.msgs, data.opts);

export const customSuccessToast = (data: ToastData) => toast.success(data.message, data.options);

export const customErrorToast = (data: ToastData) => toast.error(data.message, data.options);

export const customMessageErrorToast = (message: string) => toast.error(message, { id: message });

export const updateAvailableInfo = {
    message: () => (
        <span onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>
            Update available! Click this to update the page.
        </span>
    ),
    options: {
        duration: 300_000,
        icon: <UpdateIcon sx={{ color: '#1976D2' }} />,
        id: 'updateAvailable',
    },
};
